import { render, staticRenderFns } from "./TheIDTAddForm.vue?vue&type=template&id=eef875b0&"
import script from "./TheIDTAddForm.vue?vue&type=script&lang=js&"
export * from "./TheIDTAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports